import React, { useState } from 'react';
import { BookOpenIcon, MessageSquareIcon, CheckSquareIcon, ShieldAlertIcon, CalendarDaysIcon, RocketIcon, CheckIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { Button } from './Button';
export function TomosSection() {
  const [expandedTomo, setExpandedTomo] = useState<number | null>(null);
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const tomos = [{
    icon: BookOpenIcon,
    color: 'text-blue-600',
    bgColor: 'bg-blue-100',
    emoji: '📘',
    title: 'Tomo 1 — Manifiesto del Cliente',
    description: 'Establecé las reglas de juego desde el primer día y nunca más perseguís a alguien que "no sabía".',
    items: ['Contrato de compromiso documental listo para firmar', 'Carta de reglas de juego en 3 versiones de tono (neutro, firme, premium)', 'Formulario de bienvenida con datos clave del cliente', 'Checklist de ingreso del cliente nuevo', 'Formulario de canal único de comunicación', 'Encuadre profesional del vínculo contador-cliente', 'Guía de "qué pasa si no mandás a tiempo" para mostrarle al cliente', 'Etiquetas identificatorias por cliente para carpeta física']
  }, {
    icon: MessageSquareIcon,
    color: 'text-indigo-600',
    bgColor: 'bg-indigo-100',
    emoji: '📋',
    title: 'Tomo 2 — Protocolo de Pedido Infalible',
    description: 'Un sistema de 3 pasos para pedir documentación sin improvisar, sin rogar y sin desgastarte emocionalmente.',
    items: ['Script de pedido mensual estándar (WhatsApp + Email)', 'Secuencia completa: Nivel 1 (amable) → Nivel 2 (firme) → Nivel 3 (límite)', '20 plantillas de mensajes listos para copiar y pegar', 'Guía de tono: frases prohibidas vs frases que funcionan', 'Script para cuando el cliente manda incompleto', 'Script para cuando el cliente clava el visto', 'Script para cuando el cliente manda audios en vez de documentos', 'Checklist de pedido mensual en 5 pasos para pegar en el monitor']
  }, {
    icon: CheckSquareIcon,
    color: 'text-emerald-600',
    bgColor: 'bg-emerald-100',
    emoji: '📗',
    title: 'Tomo 3 — Checklist Mensual',
    description: 'La hoja de ruta que el cliente necesita para saber exactamente qué mandar, cuándo y cómo — sin excusas.',
    items: ['Checklist mensual por tipo de cliente (monotributista, responsable inscripto, empresa)', 'Checklist de documentos básicos por rubro', 'Checklist de novedades mensuales (altas, bajas, cambios)', 'Versión imprimible para entregar al cliente', 'Versión digital para enviar por WhatsApp o email', 'Checklist de verificación al recibir la documentación', 'Control de documentos recibidos vs pendientes', 'Resumen de cierre mensual por cliente']
  }, {
    icon: ShieldAlertIcon,
    color: 'text-red-600',
    bgColor: 'bg-red-100',
    emoji: '📕',
    title: 'Tomo 4 — El Muro de Excusas',
    description: 'Respuestas listas para cada excusa, para que nunca más te quedes sin saber qué contestar.',
    items: ['Las 15 excusas más comunes del cliente desordenado', 'Respuesta exacta para cada excusa (copia y pega)', 'Script para el cliente que siempre dice "mañana te mando"', 'Script para el cliente que manda tarde y encima se queja', 'Script para el cliente que pide prórroga todos los meses', 'Guía de manejo de cliente resistente sin conflicto', 'Protocolo de "cliente en rojo" (qué hacer cuando no hay caso)', 'Carta de advertencia de rescisión de servicio (versión profesional)']
  }, {
    icon: CalendarDaysIcon,
    color: 'text-amber-600',
    bgColor: 'bg-amber-100',
    emoji: '📓',
    title: 'Tomo 5 — Calendario de Gestión',
    description: 'Un organizador visual anual para que nunca más se te pase un vencimiento por documentación incompleta.',
    items: ['Calendario anual de vencimientos impositivos clave', 'Organizador mensual configurable por cliente', 'Tablero de control semanal (12 minutos por semana)', 'Semáforo visual por cliente (verde / amarillo / rojo)', 'Registro de faltantes acumulados por cliente', 'Alertas de documentación crítica por fecha', 'Sistema de prioridades: qué resolver primero cada mes', 'Hoja de resumen de estado de cartera']
  }, {
    icon: RocketIcon,
    color: 'text-purple-600',
    bgColor: 'bg-purple-100',
    emoji: '📔',
    title: 'Tomo 6 — Onboarding Turbo',
    description: 'Para que el cliente nuevo entre ordenado desde el primer día y nunca más tengas que enseñarle cómo mandarte info.',
    items: ['Formulario de bienvenida completo (datos, canal, preferencias)', 'Carta de presentación profesional del estudio', 'Guía "Cómo trabajamos" para entregar al cliente nuevo', 'Checklist de primer mes con el cliente', 'Formulario de diagnóstico documental inicial', 'Protocolo de primer pedido de documentación', 'Kit de incorporación digital para enviar por WhatsApp o email', 'Checklist de validación: cliente listo para operar']
  }];
  return <section id="tomos" className="py-14 bg-slate-50" data-id="element-209">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-210">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-211">
          <h2 className="text-2xl md:text-4xl font-black text-[#1e3a5f] mb-3" data-id="element-212">
            ¿Qué incluye el Sistema PRO: Cero Persecución?
          </h2>
          <p className="text-base text-gray-600 font-medium" data-id="element-213">
            6 Tomos en PDF A4 imprimible con plantillas, scripts, checklists y
            recursos listos para usar con tus clientes desde el primer día.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10" data-id="element-214">
          {tomos.map((tomo, index) => {
          const isExpanded = expandedTomo === index;
          return <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow" data-id="element-215">
                <div className="p-5 cursor-pointer" onClick={() => setExpandedTomo(isExpanded ? null : index)} data-id="element-216">
                  <div className="flex items-center justify-between" data-id="element-217">
                    <div className="flex items-center gap-3" data-id="element-218">
                      <div className={`p-2.5 rounded-lg ${tomo.bgColor} ${tomo.color}`} data-id="element-219">
                        <tomo.icon className="w-5 h-5" data-id="element-220" />
                      </div>
                      <div data-id="element-221">
                        <h3 className="text-base font-bold text-gray-900 leading-tight" data-id="element-222">
                          {tomo.title}
                        </h3>
                        <p className="text-xs text-gray-500 mt-0.5" data-id="element-223">
                          {tomo.description}
                        </p>
                      </div>
                    </div>
                    {isExpanded ? <ChevronUpIcon className="w-5 h-5 text-gray-400 flex-shrink-0 ml-2" data-id="element-224" /> : <ChevronDownIcon className="w-5 h-5 text-gray-400 flex-shrink-0 ml-2" data-id="element-225" />}
                  </div>
                </div>

                {isExpanded && <div className="px-5 pb-5 pt-0 border-t border-gray-100" data-id="element-226">
                    <ul className="space-y-2 mt-3" data-id="element-227">
                      {tomo.items.map((item, i) => <li key={i} className="flex items-start" data-id="element-228">
                          <CheckIcon className="w-4 h-4 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-229" />
                          <span className="text-sm text-gray-600" data-id="element-230">{item}</span>
                        </li>)}
                    </ul>
                  </div>}
              </div>;
        })}
        </div>

        <div className="text-center" data-id="element-231">
          <Button onClick={scrollToPricing} className="text-base px-8 py-4" data-id="element-232">
            👉 Acceder a los 6 Tomos ahora
          </Button>
        </div>
      </div>
    </section>;
}